import React from 'react';
import { Button } from 'reactstrap';
import { PropertiesList } from '../../models/propertyModel';

interface Props {
  property: PropertiesList;
  setBrokerProperty: (property: PropertiesList) => void;
  setBrokerModalOpen: (open: boolean) => void;
}

const PropertyBrokerDetail: React.FC<Props> = ({ property, setBrokerProperty, setBrokerModalOpen }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <span style={{
        fontWeight: 700,
        fontSize: 14,
        color: '#6c757d',
        letterSpacing: 1,
        marginRight: 4,
      }}>
        BROKER
      </span>
      {/* Línea vertical */}
      <span style={{
        display: 'inline-block',
        width: 1,
        height: 22,
        background: '#e0e0e0',
        margin: '0 8px',
        verticalAlign: 'middle',
      }} />
      <span style={{
        fontWeight: 500,
        fontSize: 15,
        color: '#343a40',
      }}>
        {property.brokerInfo?.name || ''}
      </span>
      <Button
        size="sm"
        color="primary"
        outline
        style={{
          borderRadius: 12,
          padding: '2px 10px',
          fontSize: 13,
          boxShadow: '0 1px 4px 0 rgba(44,62,80,0.06)',
          background: '#f4f6fa',
          border: '1px solid #825ee4',
          color: '#825ee4',
          marginLeft: 8,
        }}
        className="edit-btn"
        title="Editar broker"
        onClick={() => {
          setBrokerProperty(property);
          setBrokerModalOpen(true);
        }}
      >
        <i className="fas fa-edit" />
      </Button>
    </div>
    {property.brokerInfo?.phone && (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginLeft: 2 }}>
        <i className="fas fa-phone" style={{ fontSize: 15, color: '#6c757d' }} />
        <span style={{ color: '#6c757d', fontSize: 15 }}>
          {property.brokerInfo?.area_code ? `${property.brokerInfo.area_code} ` : ''}
          {property.brokerInfo?.phone}
        </span>
      </div>
    )}
    {property.brokerInfo?.email && (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginLeft: 2 }}>
        <i className="fas fa-envelope" style={{ fontSize: 15, color: '#6c757d' }} />
        <span style={{ color: '#6c757d', fontSize: 15 }}>
          {property.brokerInfo?.email}
        </span>
      </div>
    )}
  </div>
);

export default PropertyBrokerDetail;